export default "<md-content layout-padding>\n  <p translate=\"forbidden.message\"></p>\n</md-content>\n";